<div class="confirm-backdrop" (click)="cancelled.emit()" (keydown.escape)="cancelled.emit()">
  <div class="confirm-modal" role="alertdialog" aria-modal="true"
       [attr.aria-labelledby]="'confirm-title'" [attr.aria-describedby]="'confirm-msg'"
       (click)="$event.stopPropagation()">
    <h2 id="confirm-title" class="confirm-title">{{ title() }}</h2>
    <p id="confirm-msg" class="confirm-message">{{ message() }}</p>
    <div class="confirm-actions">
      <button class="btn btn-cancel" (click)="cancelled.emit()">{{ cancelLabel() }}</button>
      <button class="btn btn-confirm" [class.destructive]="destructive()"
              (click)="confirmed.emit()">{{ confirmLabel() }}</button>
    </div>
  </div>
</div>

